import React from "react";
import { joinClasses } from "../../utils/textUtils";
import iconsSelection from "../../styles/icomoon/selection.json";

interface Props {
  i?: string;
  className?: string;
}

export default function Icon(props: Props) {
  const { i, className } = props;

  const avaialbleIcons = iconsSelection.icons.map(
    (icon) => icon.properties.name
  );

  if (i) {
    const iconName = i.replace("icons-", "");
    if (avaialbleIcons.includes(iconName))
      return <i className={joinClasses([`icons-${iconName}`, className])} />;
    return <i style={{ color: "gold" }}>(icon name not in list: {iconName})</i>;
  }

  return <i style={{ color: "red" }}>(icon name missing)</i>;
}
